export default "__VITE_ASSET__B89Zh5$x__"